import SeoHead from "@/Component/Seo/SeoHead";
import AboutUs from "@/Component/Module/AboutUs";
import { fetchPageSeo } from "@/utils/pageSeo";

export default function AboutUsPage({ seo, seoCountry }) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="About Us | Next Holidays" />
      <AboutUs />
    </>
  );
}

export async function getServerSideProps(context) {
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  return {
    props: {
      seo: seoResult.seo,
      seoCountry: seoResult.seoCountry,
    },
  };
}
